const init = () => {
    $("form").formulator();
};

export default {
    init
};
